module.exports = __webpack_public_path__ + "img/MV.a2b52a71.svg";